/* BURGER */

const burger = document.querySelector('.burger');
const menu = document.querySelector('.menu');
const body = document.body;
const prevBtn = document.querySelector(".prev");
const nextBtn = document.querySelector(".next");
var links = document.querySelectorAll(".lien--menu");

var liElements= document.querySelectorAll('.li');


burger.addEventListener('click', function(){
  menu.classList.toggle('menu--open');
  body.classList.toggle('body--overnone');
});

links.forEach((link) => {
  link.addEventListener("click", () => {
    if(body.classList.contains('body--overnone')){
      body.classList.remove('body--overnone');
    }
  })
})



for (let i = 0; i < liElements.length; i++) {
   liElements[i].addEventListener('click', function(){
      menu.classList.toggle('menu--open');
   })
}


/* Slider from https://www.w3schools.com/howto/tryit.asp?filename=tryhow_js_slideshow */

prevBtn.addEventListener("click", () => {
  plusSlides(-1);
})

nextBtn.addEventListener("click", () => {
  plusSlides(1);
})

var slideIndex = 1;
showSlides(slideIndex);

function plusSlides(n){
  showSlides(slideIndex += n);
}

function currentSlide(n){
  showSlides(slideIndex = n);
}

function showSlides(n){
  var i;
  var slides = document.getElementsByClassName("mySlides");
  var dots = document.getElementsByClassName("dot");
  if (n > slides.length) {slideIndex = 1}    
  if (n < 1) {slideIndex = slides.length}
  for (i = 0; i < slides.length; i++) {
      slides[i].classList.remove("flex--slide");
      slides[i].classList.add("hide");  
  }
  for (i = 0; i < dots.length; i++) {
      dots[i].className = dots[i].className.replace(" active", "");
  }
  
  slides[slideIndex-1].classList.remove("hide");
  slides[slideIndex-1].classList.add("flex--slide");

  dots[slideIndex-1].className += " active";
}

